module.exports = __webpack_public_path__ + "7e4b29ba/img/splash-icon.07a7c465.svg";